/**
 * IGNIERE §118: blog 日付を YYYY.MM.DD 表示に統一。
 *
 * 対象 selector: .blog-post-details time[datetime]
 * 変更内容    : 表示テキストを datetime 属性値から YYYY.MM.DD で組み立てて置換。
 * 冪等性      : data-ig118="applied" マークで多重適用を防止。
 * 対応先の core 復元: blocks/_blog-post-info-text.liquid の time タグ format を
 *                    upstream の time_tag ローカライズ表示（例「2026年7月14日」）に戻しても、
 *                    本モジュールが常に YYYY.MM.DD に上書きするので視覚結果は同じ。
 */
(function () {
  'use strict';
  const IG = window.IGNIERE_RUNTIME;
  if (!IG || !IG.register) return;

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatFromDatetime(dt) {
    if (!dt) return null;
    // "2026-07-14" or "2026-07-14T00:00:00Z" のどちらでも先頭 10 文字だけ拾える
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dt);
    if (m) return m[1] + '.' + m[2] + '.' + m[3];
    // フォールバック: Date parse
    const d = new Date(dt);
    if (isNaN(d.getTime())) return null;
    return d.getUTCFullYear() + '.' + pad2(d.getUTCMonth() + 1) + '.' + pad2(d.getUTCDate());
  }

  IG.register('118-blog-date', {
    apply(root) {
      // blog-post-details コンテナ配下の time タグを走査
      const nodes = root.querySelectorAll
        ? root.querySelectorAll('.blog-post-details time[datetime]:not([data-ig118="applied"])')
        : [];
      for (const t of nodes) {
        const formatted = formatFromDatetime(t.getAttribute('datetime'));
        if (formatted) {
          t.textContent = formatted;
          t.setAttribute('data-ig118', 'applied');
        }
      }
    },
  });
})();
